import * as t from 'io-ts';

declare global {
  interface Window {
    Chargebee: ChargebeeInteface;
  }
}

// @ts-ignore
export const { Chargebee } = window;

export interface PortalCallbacks {
  loaded: Function;
  close: Function;
  visit(sectionType: string): void;
}

interface PortalForwardOptions {
  sectionType: string;
  params: {
    subscriptionId: string;
    paymentSourceId: string;
  };
}

export interface PlanDetailsCallbackAttributes {
  subscription: { id: string };
}

export interface PlanDetailsCallbacks extends PortalCallbacks {
  subscriptionChanged: (attributes: PlanDetailsCallbackAttributes) => void;
  subscriptionCustomFieldsChanged: (attributes: PlanDetailsCallbackAttributes) => void;
  subscriptionCancelled: (attributes: PlanDetailsCallbackAttributes) => void;
  scheduledCancellationRemoved: (attributes: PlanDetailsCallbackAttributes) => void;
  subscriptionReactivated: (attributes: PlanDetailsCallbackAttributes) => void;
}

export interface PaymentDetailsCallbacks extends PortalCallbacks {
  paymentSourceAdd(status: string): void;
  paymentSourceUpdate: Function;
  paymentSourceRemove: Function;
}

export type PortalSections = {
  ACCOUNT_DETAILS: 'account_details';
  ADDRESS: 'portal_address';
  ADD_PAYMENT_SOURCE: 'portal_add_payment_method';
  BILLING_HISTORY: 'portal_billing_history';
  CHOOSE_PAYMENT_METHOD_FOR_SUBSCRIPTION: 'portal_choose_payment_method';
  EDIT_ACCOUNT_DETAILS: 'portal_edit_account';
  EDIT_BILLING_ADDRESS: 'portal_edit_billing_address';
  EDIT_PAYMENT_SOURCE: 'portal_edit_payment_method';
  EDIT_SHIPPING_ADDRESS: 'portal_edit_shipping_address';
  EDIT_SUBSCRIPTION: 'edit_subscription';
  EDIT_SUBSCRIPTION_CUSTOM_FIELDS: 'portal_edit_subscription_cf';
  PAYMENT_SOURCES: 'portal_payment_methods';
  SUBSCRIPTION_CANCELLATION: 'sub_cancel';
  SUBSCRIPTION_DETAILS: 'sub_details';
  VIEW_PAYMENT_SOURCE: 'portal_view_payment_method';
  VIEW_SCHEDULED_CHANGES: 'scheduled_changes';
};

export const portalSection: PortalSections = {
  ACCOUNT_DETAILS: 'account_details',
  ADDRESS: 'portal_address',
  ADD_PAYMENT_SOURCE: 'portal_add_payment_method',
  BILLING_HISTORY: 'portal_billing_history',
  CHOOSE_PAYMENT_METHOD_FOR_SUBSCRIPTION: 'portal_choose_payment_method',
  EDIT_ACCOUNT_DETAILS: 'portal_edit_account',
  EDIT_BILLING_ADDRESS: 'portal_edit_billing_address',
  EDIT_PAYMENT_SOURCE: 'portal_edit_payment_method',
  EDIT_SHIPPING_ADDRESS: 'portal_edit_shipping_address',
  EDIT_SUBSCRIPTION: 'edit_subscription',
  EDIT_SUBSCRIPTION_CUSTOM_FIELDS: 'portal_edit_subscription_cf',
  PAYMENT_SOURCES: 'portal_payment_methods',
  SUBSCRIPTION_CANCELLATION: 'sub_cancel',
  SUBSCRIPTION_DETAILS: 'sub_details',
  VIEW_PAYMENT_SOURCE: 'portal_view_payment_method',
  VIEW_SCHEDULED_CHANGES: 'scheduled_changes',
};

export interface Portal {
  open(options: PortalCallbacks, forwardOptions: PortalForwardOptions): void;
  openSection(
    options: PortalOpenSectionOptions,
    callbacks: PortalCallbacks
  ): void;
}

export interface PortalOpenSectionOptions {
  sectionType: string;
  layout: Layout;
  params: {
    subscriptionId: string;
  };
}

export interface ChargebeeInteface {
  init(options: InitOptions): void;
  getInstance(): ChargebeeInstance;
  getPortalSections(): PortalSections;
  createChargebeePortal(): Portal;
}

export type InitOptions = {
  site: string;
  publishableKey: string;
  enableGTMTracking: boolean;
};

export type ChargebeeInstance = {
  site: string;
  publishableKey: string;
  openCheckout(options: OpenCheckoutOptions): void;
  closeAll(): void;
};

export type OpenCheckoutOptions = {
  hostedPage: Function;
  layout?: Layout;
  loaded: Function;
  success(hostedPageId: string): void;
  close: Function;
  step(currentStep: string): void;
  error(error: string): void;
};

export enum Layout {
  IN_APP = 'in_app',
  FULL_PAGE = 'full_page',
}
